//error actions
export const GET_ERRORS = "GET_ERRORS";
export const CLEAN_UP_ERRORS = "CLEAN_UP_ERRORS";

//success actions
export const GET_SUCCESS = "GET_SUCCESS";
export const REMOVE_SUCCESS =  "REMOVE_SUCCESS";

//auth actions
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const USER_REGISTERED = "SET_USER_REGISTERED";

//modplan actions
export const SET_BOARD_FILLED = "SET_BOARD_FILLED";
export const SET_MODULES = "SET_MODULES";
export const SET_RULES = "SET_RULES";
export const SET_CALL_BACKEND_NOW = "SET_CALL_BACKEND_NOW";
export const SET_SELECTED_MODULES = "SET_SELECTED_MODULES";
export const SET_MODULE_LOCATION = "SET_MODULE_LOCATION";
export const SET_CURRRENT_SEMESTER = "SET_CURRENT_SEMESTER";
export const SET_MODPLAN_LOADING = "SET_MODPLAN_LOADING";
export const CLEAN_UP_MODPLAN = "CLEAN_UP_MODPLAN";

//cap actions
export const SET_SEMESTER_OPTIONS = "SET_SEMESTER_OPTIONS";
export const SET_CAP = "SET_CAP";
export const CALCULATE_CAP = "CALCULATE_CAP";
export const CLEAN_UP_CAP = "CLEAN_UP_CAP";

//settings actions
export const SET_FACULTY = "SET_FACULTY";
export const SET_MAJOR = "SET_MAJOR";
export const SET_USER_SETTINGS = "SET_USER_SETTINGS";
export const SET_CURRENT_SEMESTER = "SET_CURRENT_SEMESTER";
export const SET_MATRICULATION_OPTIONS = "SET_MATRICULATION_OPTIONS";
export const SET_TARGET_GRAD_OPTIONS = "SET_TARGET_GRAD_OPTIONS";
export const SET_ACAD_OPTIONS = "SET_ACAD_OPTIONS";
export const SET_EDIT_ALL = "SET_EDIT_ALL";
export const SETTINGS_LOADING = "SETTINGS_LOADING";
export const SET_FIRST_RENDER = "SET_FIRST_RENDER";
export const CLEAN_UP_SETTINGS = "CLEAN_UP_SETTINGS";
